import React, { useEffect, useState } from "react";
import CustomTable from "../../../../../../components/table/table";
import "../style.css";
import CommonForm from "../../../../../../components/commonform/commonForm";
import Snackbar from "../../../../../../components/snackbar/snackbar";

export default function View(props) {
    const [agreeDeclaration1, setAgreeDeclaration1] = useState(false);
    const [agreeDeclaration2, setAgreeDeclaration2] = useState(false);
    const [snackMessage, setSnackMessage] = useState("");
    const [isSnackError, setIsSnackError] = useState(false);
    const [snackOpen, setSnackOpen] = useState(false);

  console.log(props.basicData);
  const servInstance = process.env.REACT_APP_BASE_URL;
  let result = servInstance.substring(0, servInstance?.length - 4);
  {
    console.log(props?.basicData);
  }
  useEffect(() => {
    setAgreeDeclaration1(!!props?.basicData?.declaration_truth);
    setAgreeDeclaration2(!!props?.basicData?.declaration_promo);
  }, [props?.basicData?.declaration_truth, props?.basicData?.declaration_promo]);
  const handleCheckChangeDeclaration1 = (e) => {
    let checked = e.target.checked;
    setAgreeDeclaration1(checked);
  };
  const handleCheckChangeDeclaration2 = (e) => {
    let checked = e.target.checked;
    setAgreeDeclaration2(checked);
  };
  const snackbarClose = (flag) => {
    setSnackMessage("");
    setIsSnackError(false);
    setSnackOpen(false);
    if (!flag) {
      props.logout();
    }
  };

  const handleCheckDeclaration = () => {
    if (!agreeDeclaration1 || !agreeDeclaration2) {
      setSnackMessage("Please agree to both declarations before submitting.");
      setIsSnackError(true);
      setSnackOpen(true);
      return;
    }
    props.action(2);
  }

  return (
    <div>
      <div className="view-container">
        <h6><b>Institution Details</b></h6>
        <hr />
        <div className="data">
          <div className="row">
            <div className="col-3">Name of the Institution</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.institution_name ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Registered Office Address</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.address ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Headquarters Details</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.headquaters_detail ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Institution Logo</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.logo_name ?? ""}</div>
          </div>
        </div>

        <h6 className="mt-3"><b>Contact Information</b></h6>
        <hr />
        <div className="data">
          <div className="row">
            <div className="col-3">Contact Number</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.phone_number ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Alternate Contact Number</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.alternate_phone && (
                <>
                  {props.basicData.country_code &&
                    props.basicData.country_code !== "" &&
                    props.basicData.country_code !== "undefined" &&
                    props.basicData.country_code !== "null" && (
                      <>
                        {props.basicData.country_code ?? ""}{" "}
                        {props.basicData.country_code && props.basicData.country_code !== "" ? "-" : ""}{" "}
                      </>
                    )}
                </>
              )}
              {props.basicData.alternate_phone ?? ""}
            </div>
          </div>
          <div className="row">
            <div className="col-3">Email ID</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.email}</div>
          </div>
          <div className="row">
            <div className="col-3">Alternate Email ID</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.alternate_email ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Authorized Person</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData.authorized_person_name || props.basicData.authorized_person_designation
                ? `${props.basicData.authorized_person_name ?? ""} (${props.basicData.authorized_person_designation ?? ""})`
                : props.basicData.contact_person_details ?? ""}
            </div>
          </div>
        </div>

        <h6 className="mt-3"><b>Academic Information</b></h6>
        <hr />
        <div className="data">
          <div className="row">
            <div className="col-3">Financial Year</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.financial_year ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Affiliation Details</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.affiliation ?? ""}</div>
          </div>
          <div className="row">
            <div className="col-3">Total Number of Students</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.total_students}</div>
          </div>
          <div className="row">
            <div className="col-3">Courses Offered</div>
            <div className="col-1">:</div>
            <div className="col-7">
              {props.basicData?.course_details?.map((dom, i) => (
                <div key={i}><b>{dom.course_type}</b> : {dom.course_name}</div>
              ))}
            </div>
          </div>
        </div>

        <h6 className="mt-3"><b>Institution Profile</b></h6>
        <hr />
        <div className="data">
          <div className="row">
            <div className="col-3">Brief Note on Institution Activities</div>
            <div className="col-1">:</div>
            <div className="col-7">{props.basicData.notes_institutions ?? ""}</div>
          </div>
        </div>

        <h6 className="mt-3"><b>Document Upload</b></h6>
        <hr />
        <div className="data">
          {props.update === true && typeof props?.basicData?.file_registration_proof === "string" ? (
            <div className="row">
              <div className="col-3 field-titles">Uploaded Proof of Registration</div>
              <div className="col-1 hideonMobile">:</div>
              <div className="col-7">
                <a
                  onClick={() => {
                    window.open(`${result}${props?.basicData?.file_registration_proof}`, "_blank");
                  }}
                  className="detailFile"
                >
                  View
                </a>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-3">Uploaded Proof of Registration</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.file_name_proof}</div>
            </div>
          )}

          {props.update === true && typeof props?.basicData?.file_submitted_record === "string" ? (
            <div className="row">
              <div className="col-3 field-titles">Upload Request Letter on Institution Letterhead</div>
              <div className="col-1 hideonMobile">:</div>
              <div className="col-7">
                <a
                  onClick={() => {
                    window.open(`${result}${props?.basicData?.file_submitted_record}`, "_blank");
                  }}
                  className="detailFile"
                >
                  View
                </a>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-3">Upload Request Letter on Institution Letterhead (signed by Head/Authorized Signatory)</div>
              <div className="col-1">:</div>
              <div className="col-7">{props.basicData.file_name_request ?? ""}</div>
            </div>
          )}
        </div>
        <div className="d-flex pt-3">
          <div>
            <center>
              <CommonForm
                fieldType="checkbox"
                value={agreeDeclaration1}
                required
                checked={agreeDeclaration1}
                onChange={(e) => handleCheckChangeDeclaration1(e)}
                label=""
                {...props}
              />
            </center>
          </div>
          <div className="mt-1">
            I hereby, declare that the entries made by me in the form are complete and true to the best of my knowledge and based on records
          </div>
        </div>
        <div className="d-flex pt-3">
          <div>
            <center>
              <CommonForm
                fieldType="checkbox"
                value={agreeDeclaration2}
                required
                checked={agreeDeclaration2}
                onChange={(e) => handleCheckChangeDeclaration2(e)}
                label=""
                {...props}
              />
            </center>
          </div>
          <div className="mt-1">
            I hereby agree to use the institution’s name & logo in the promotional activities of Kerala Spacepark
          </div>
        </div>

        <div className="footer-buttons mt-3">
          <div
            className="secondary-btn"
            onClick={(e) => {
              props.action(1);
            }}
          >
            GO BACK
          </div>
          <div
            className="primary-btn"
            // onClick={(e) => {
            //   props.action(2);
            // }}
            onClick={handleCheckDeclaration}

          >
            REGISTER
          </div>
        </div>
      </div>
      {snackOpen &&
        <Snackbar
          message={snackMessage}
          error={isSnackError}
          open={snackOpen}
          close={snackbarClose}
        />

      }

    </div>
  );
}
